import React, { useEffect, useState } from "react";
import { useExtendedAuth } from "../../util/auth0";
import styled from "styled-components";
import { useAuth0 } from "@auth0/auth0-react";
import i18next from "i18next";
import { AUTH0_AUDIENCE } from "../../config";
import { useAuthFetchFromRestAPI } from "../../util/api";

const Button = styled("button")`
  background-color: #ff695f;
`;

type Props = {
    login: boolean;
};

export const LoginBoxAuth0 = ({ login }: Props) => {
    const { user, isLoading, isAuthenticated, getAccessTokenSilently, loginWithRedirect, loginWithPopup, logout } = useAuth0();
    const { handleOnAuthenticated, handleOnSignedIn } = useExtendedAuth();
    const { authFetch } = useAuthFetchFromRestAPI();
    // const [email, setEmail] = useState("");
    // const [password, setPassword] = useState("");
    // const [showEmailConfirmation, setEmailConfirmation] = useState(false)
    // const [signInLocal, setSignInLocal] = useState(signIn)
    // const location = useLocation();

    // const getReferralCodeFromQueryParam = () => {
    //     const qs = queryString.parse(location.search);
    //     if (qs.supportSignUp === "true" && qs.success === "true") {
    //         setSignInLocal(true);
    //         setEmailConfirmation(true);
    //     } else {
    //         setEmailConfirmation(false);
    //     }
    //
    //     if (qs.ref) {
    //         let referralCode = qs.ref;
    //         if (Array.isArray(referralCode)) {
    //             referralCode = referralCode[0];
    //         }
    //         localStorage.setItem('referralCode', referralCode); // for later sign-ups
    //         //console.log(`use referral code '${referralCode}' for signup`);
    //         return referralCode;
    //     } else {
    //         return localStorage.getItem('referralCode');
    //     }
    // };

    // // ToDo: look into handling of referralCode
    // const referralCode = getReferralCodeFromQueryParam();
    // const userLanguage = i18next.language;
    //
    // // This was supplied to Auth0Lock, probably not needed
    // const langOption = i18next.t('auth0lock.languageDictionary', { returnObjects: true });
    // langOption['error'] = { signUp: { 'lock.fallback': i18next.t('auth0lock.languageDictionary.genericError') } };

    const handleLoginRedirect = async (e: React.FormEvent) => {
        e.preventDefault();
        await loginWithRedirect({
            appState: { returnTo: '/' }, //account-setup or /therapien
            authorizationParams: {
                audience: AUTH0_AUDIENCE,
            },
        });
    };

    const handleLoginPopup = async (e: React.FormEvent) => {
        e.preventDefault();
        await loginWithPopup({
            authorizationParams: {
                screen_hint: login ? 'login' : 'signup',
                audience: AUTH0_AUDIENCE,
                scope: 'read:patientdata write:patientdata access:webapp'
            },
        });
        await authFetch('/api/v1/user-profile/signup', {
            method: 'POST'
        })
    };

    useEffect(() => {
        const handleEffect = async () => {
            if (!isLoading && isAuthenticated && user) {
                const token = await getAccessTokenSilently();
                handleOnAuthenticated(token, user);
            }
        }
        handleEffect();
    }, [isAuthenticated, isLoading, user]);

    return (
        <div  className="space-y-4 max-w-sm mx-auto">
            <div className="text-sm text-center">
                <button type="button" className="bg-blue-500 px-4 py-2 w-full" onClick={handleLoginPopup}>
                    {isLoading ? i18next.t('loginBox.loginSubmitLabelLoading') : i18next.t('loginBox.loginSubmitLabel')}
                </button>
            </div>
        </div>
    );
};
